export default class Colors {
  static colorString([r, g, b]) {
    return `rgb(${r}, ${g}, ${b})`;
  }
  static colorStringRaw([r, g, b]) {
    return `${r}, ${g}, ${b}`;
  }
  static darkenBy(baseColor, opacity) {
    const mask = [0, 0, 0];
    // @ts-expect-error - TS2345 - Argument of type 'number[]' is not assignable to parameter of type '[any, any, any]'.
    return Colors.mixColor(baseColor, mask, opacity);
  }
  static mixColor([r, g, b], [maskR, maskG, maskB], opacity) {
    const inverseOpacity = 1 - opacity;
    return [
    // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    parseInt(r * opacity + maskR * inverseOpacity, 10),
    // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    parseInt(g * opacity + maskG * inverseOpacity, 10),
    // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    parseInt(b * opacity + maskB * inverseOpacity, 10)];
  }
  static brightness([r, g, b]) {
    return r * 0.299 + g * 0.587 + b * 0.114;
  }
  static hexToRgb(hexColor) {
    if (!hexColor || hexColor.length !== 6) {
      throw new Error('Invalid color');
    }
    return [parseInt(hexColor.substr(0, 2), 16), parseInt(hexColor.substr(2, 2), 16), parseInt(hexColor.substr(4, 2), 16)];
  }
}
Colors.BRIGHTNESS_THRESHOLD = 180;